import { userConstants } from "../../constants/ActionTypes";

const initialState = {
    acl_routes : [],
    selected_acl_routes:[]
};
const loadState = {
    acl_routes_load : false
};

export function acl_routes(state = initialState, action) {
    switch (action.type) {  
        case userConstants.ACL_ROUTES:
            return {
                ...state,
                ...action.payload
            };
        default:
            return state
    }
}
export function acl_loaded(state = loadState, action) {
    switch (action.type) {  
        case userConstants.ACL_LOAD:
            return {
                ...state,
                ...action.payload
            };
        default:
            return state
    }
}